import { Content } from "@/ui";
import SeoHead from "@/components/SeoHead";
import styles from "./styles.module.scss";

export default function InclusivePage({ title, canonical, content }) {
  return (
    <div className={styles.cont}>
      <SeoHead title={title} canonical={canonical} />
      <Content items={content} />
    </div>
  );
}

export async function getStaticProps({}) {

  return {
    props: {
      title: "Inclusive",
      canonical: "/inclusive",
      content: [
        {
          component: "Hero",
          props: {
            background: {
              path: "inclusive.hero.background",
            },
          }
        },
        {
          component: "HorizontalImageTextSection",
          props: {
            path:  "inclusive.powerhouse",
            imagePath: "inclusive.powerhouse",
            align: "right"
          }
        },
        {
          component: "DynamicContentSection",
          props: {
            path: "inclusive.text_1"
          }
        },
        {
          component: "PlainCardSection"
        },
        {
          component: "GoalSection"
        },
        {
          component: "OfferSection",
          props: {
            titlePath: "inclusive.offer.title",
            items: [
              {imagePath: 'inclusive.offer.item_1', path: 'inclusive.offer.item_1'},
              {imagePath: 'inclusive.offer.item_2', path: 'inclusive.offer.item_2'},
              {imagePath: 'inclusive.offer.item_3', path: 'inclusive.offer.item_3'},
            ]
          }
        },
        {
          component: "DynamicContentSection",
          props: {
            path: "inclusive.text_2"
          }
        },
        {
          component: "OfferSection",
          props: {
            titlePath: "inclusive.pathway.title",
            items: [
              {imagePath: 'inclusive.pathway.item_1', path: 'inclusive.pathway.item_1'},
              {imagePath: 'inclusive.pathway.item_2', path: 'inclusive.pathway.item_2'},
              {imagePath: 'inclusive.pathway.item_3', path: 'inclusive.pathway.item_3'},
            ],
            buttons: [
              {title: 'INTERESTED IN MENTORING?', href: '/'},
              {title: 'INTERESTED IN BECOMING A SPEAKER?', href: '/'},
            ]
          }
        },
      ],
    },
  };
}
